// Fetches Embed Url and Embed token for PowerBi
import {stableGetRequest} from '../requests/stableGetRequest.js'
import CryptoJS from "crypto-js";
import handlePowerBiAuth from "./handlePowerBiAuth";
const powerBiLocalVar = "powerBiEmbedInfo"

export default async function handlePowerBiReport(powerBiReportInfo, token) {
  var header = {
    method: "GET",
    headers: {
      Authorization: token,
    },
  };

  // Fetch Current Access Token
  var token = await handlePowerBiAuth(token)

  // FETCH - EMBEDDED INFO
  if(powerBiReportInfo !== null && powerBiReportInfo !== undefined && powerBiReportInfo !== '') {
    let newData = await stableGetRequest(process.env.REACT_APP_POWERBI_API+'powerbi-embedded-report'+`?workspace_id=${powerBiReportInfo.workspace_id}&report_id=${powerBiReportInfo.report_id}&access_token=${token.access_token}`,header, JSON.stringify(powerBiReportInfo))
    console.log("SET POWERBI", newData)
    localStorage.setItem(
      powerBiLocalVar,
      CryptoJS.AES.encrypt(
        JSON.stringify(newData),
        process.env.REACT_APP_PASS
        ).toString()
        );
    // return true
    return newData
  }
}



// WEBPACK FOOTER //
// ./src/util/powerBi/handlePowerBiReport.jsx